<template>
  <div class="flex flex-column gap-3">
    <h3 class="m-0 flex gap-2 align-items-center">Statistic</h3>

    <a-spin :spinning="loading">
      <div v-if="statistic && statistic.length" class="list">
        <div v-for="type in statistic" :key="type.key" class="item">
          <h4 class="flex justify-content-between gap-3">
            <span>{{ type.title }}</span> <span>{{ type.total }}</span>
          </h4>
          <p v-for="subtype in type.sub_types" :key="subtype.key" class="flex justify-content-between gap-3">
            <span> {{ subtype.title }}:</span> <b>{{ subtype.value }}</b>
          </p>
        </div>
      </div>
      <span v-else>No Statistic Found</span>
    </a-spin>
  </div>
</template>

<script>
import { Spin } from 'ant-design-vue'

export default {
  components: {
    'a-spin': Spin
  },
  props: {
    statistic: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {},
  methods: {}
}
</script>

<style>
.list {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.list h4 {
  font-size: 16px;
  font-weight: 700;
}

.item {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  border: 1px solid var(--border-color-base);
  border-radius: var(--border-radius);
}
</style>
